import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import {
  Character,
  CharacterFeature,
  CharacteristicFeature,
  RollableTable
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import StringBox from "@components/input/strings/StringBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  character: Character;
  char_feature: CharacterFeature;
  // value: string;
  onChange: (changed: string) => void;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterCharacteristicInput({ 
  character, 
  char_feature,
  // value,
  onChange
}: Props) {
  // const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  // const [ping, setPing] = useState(false);
  // const [expanded, setExpanded] = useState(false);
  const [table, setTable] = useState<RollableTable | null>(null);
  const [value, setValue] = useState(char_feature.feature_options[0]);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = async () => {
    // setLoading(true);
    const characteristic_feature = char_feature.floating_feature as CharacteristicFeature;
    // api.getObjects({ data_type: "rollable_table", c_options: character.c_options, filter: { "_id*ObjectIDs": [characteristic_feature.rollable_table_id] } }).then(res => {
    const table_finder = data_util.rollable_tables.find(o => o._id === characteristic_feature.rollable_table_id);
    if (table_finder) {
      await api.loadObject(table_finder);
      setTable(table_finder);
    }
    //   setLoading(false);
    // });
    setFetched(true);
  }

  const renderTable = () => {
    const characteristic_feature = char_feature.floating_feature as CharacteristicFeature;
    if (table) {
      return (
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ border: "1px solid #000" }}
          size={{
            xs: 12
          }}>
          <Grid
            container
            spacing={0}
            direction="row"
            style={{ fontWeight: "bold", borderBottom: "1px solid #000" }}
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 2
              }}>{ `d${table.dice_size}` }</Grid>
            <Grid
              size={{
                xs: 8
              }}>{ characteristic_feature.header1 }{ characteristic_feature.header2 !== "" && ` (${characteristic_feature.header2})` }</Grid>
            <Grid
              size={{
                xs: 2
              }}>
              <ButtonBox
                name="Random"
                onClick={() => {
                  const roll = common_util.get_random(table.dice_size);
                  const option_finder = table.roll_options.filter(o => o.min_roll <= roll && roll <= o.max_roll);
                  if (option_finder.length === 1) {
                    const option = option_finder[0];
                    const new_value = (value.length > 0 ? value.trim() + " " : "") + option.result.trim();
                    onChange(new_value);
                    // setPing(!ping);
                    setValue(new_value);
                  }
                }}
              />
            </Grid>
          </Grid>
          { table.roll_options.map((option, key) => {
            return (
              <Grid
                key={key}
                container
                spacing={0}
                direction="row"
                className={ key % 2 === 1 ? "alternate" : "" }
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 2
                  }}>{ option.min_roll }{ option.min_roll !== option.max_roll && `-${option.max_roll}` }</Grid>
                <Grid
                  size={{
                    xs: 8
                  }}>{ option.result }</Grid>
                <Grid
                  size={{
                    xs: 2
                  }}>
                  <ButtonBox
                    name="+Add"
                    onClick={() => {
                      const new_value = (value.length > 0 ? value.trim() + " " : "") + option.result.trim();
                      onChange(new_value);
                      // setPing(!ping);
                      setValue(new_value);
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      );
    }
    return null;
  }

  if (!fetched) {
    return (
      <LoadingBox />
    );
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox 
            name={char_feature.name}
            value={value}
            multiline
            onBlur={(changed: string) => {
              onChange(changed);
              // setPing(!ping);
              setValue(changed);
            }}
          />
        </Grid>
        { renderTable() }
      </Grid>
    );
  }
}
